import { useContext, useEffect } from 'react';
import { ConfigContext, WidgetStateContext } from '@/context';
import { ConsentBanner, PrivacyCenter, FloatingButton } from '@/components';
import { api } from '@/utils/api';
import { useWidgetStateContext } from './context/WidgetStateContext';
import { createWidgetProxy } from './WidgetProxy';

function App() {
  const { configLoaded } = useContext(ConfigContext);
  if (!configLoaded) {
    return <></>;
  }
  const { setTopRef } = useContext(WidgetStateContext);

  // Setup the widget proxy. This is used to communicate with the widget
  // from the host page for things like opening the widget.
  const widgetStateContextValue = useWidgetStateContext();
  useEffect(() => {
    api.plugin.widget = createWidgetProxy(widgetStateContextValue);
  }, [widgetStateContextValue]);

  return (
    <div
      ref={setTopRef}
      className="light bg-background text-foreground relative z-[2147483000] text-sm font-medium leading-relaxed"
    >
      <PrivacyCenter zIndex={300} />
      <ConsentBanner zIndex={200} />
      <FloatingButton zIndex={100} />
    </div>
  );
}

export default App;
